module.exports = __webpack_public_path__ + "media/winner_full_house_4.432fd97b.mp3";